import { lazy } from 'react';

const ProfilePageConfig = {
	settings: {
		layout: {
			config: {
				footer: {
					display: true,
					style: 'static'
				},
			}
		}
		
	},
	routes: [
		{
			path: '/auth/my-profile',
			component: lazy(() => import('./ProfilePage'))
		}
	]
};

export default ProfilePageConfig;
